import { api } from '@/services/api.config';

// Returns the body unchecked instead of throwing on `!Success`: here `Success: false` is the answer
// (the session is gone), not a failure, and the caller must also tell it apart from a body that is
// no API response at all — see `verifyStoredSession`. No `pinging…` flag: nothing renders it, the
// login provider's `isAuthenticated === null` already is the pending state.
export default function usePartnerAuthPing() {
  async function pingPartnerAuth() {
    try {
      return await api.postPartnerAuthPing();
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  return { pingPartnerAuth };
}
